import { DefaultSuccessPhase as SuccessPhase } from './components/defaultSuccessPhase'
import { ErrorPhase } from './components/errorPhase'
import { StartPhase } from './components/startPhase'
import { UploadingPhase } from './components/uploadingPhase'
import { PHASES } from './reducer'
import React from 'react'

interface PhasesProps {
  expectedMimeTypes: string[]
  fileName: string
  handleDrop: (files: File[]) => void
  onDeleteSelectedFile: () => void
  onSelectFileToUpload: () => void
  current: PHASES
  children: React.ReactNode
  errors: Record<string, string>[]
  renderErrors: (errors: Record<string, string>[]) => React.ReactNode
}

export const Phases = ({ children, current, ...rest }: PhasesProps) => {
  const successPhase = children ?? <SuccessPhase />

  switch (current) {
    case PHASES.START:
      return <StartPhase {...rest} />
    case PHASES.UPLOADING:
      return <UploadingPhase />
    case PHASES.SUCCESS:
      return successPhase
    case PHASES.ERROR:
      return <ErrorPhase {...rest} />
    default:
      return null
  }
}
